import Vue from 'vue'
import Router from 'vue-router'
import i18n from './i18n/index'
import LocaleWrapper from './views/LocaleWrapper'
import Home from './views/Home'
import Privacy from './views/Privacy'
import NotFound from './views/NotFound'
import FormSuccess from './views/FormSuccess'
import FormFailure from './views/FormFailure'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/:locale',
      component: LocaleWrapper,
      props: ({ params }) => ({
        locale: params.locale
      }),
      children: [
        {
          path: 'not-found',
          name: 'not-found',
          component: NotFound,
          meta: {
            i18nKey: 'notFound'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          path: ':fromSite/success',
          name: 'form-success',
          component: FormSuccess,
          props: ({ params }) => ({
            fromSite: params.fromSite
          }),
          meta: {
            i18nKey: 'formSuccess'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          path: ':fromSite/failure',
          name: 'form-failure',
          component: FormFailure,
          props: ({ params }) => ({
            fromSite: params.fromSite
          }),
          meta: {
            i18nKey: 'formFailure'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          path: 'privacy-policy/:fromSite',
          name: 'privacy',
          component: Privacy,
          props: ({ params }) => ({
            fromSite: params.fromSite
          }),
          pathToRegexpOptions: { strict: true }
        },
        {
          path: ':fromSite',
          name: 'home',
          component: Home,
          props: ({ params }) => ({
            fromSite: params.fromSite
          }),
          meta: {
            i18nKey: 'home'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          path: '*',
          redirect: { name: 'not-found' }
        }
      ]
    },
    {
      path: '*',
      redirect: { name: 'not-found', params: { locale: 'it' } }
    }
  ]
})

router.beforeResolve((to, from, next) => {
  document.title = typeof to.meta.i18nKey !== 'undefined'
    ? i18n.t(`${to.meta.i18nKey}.pageTitle`, to.params.locale)
    : i18n.t('defaultPageTitle', to.params.locale)

  next()
})

export default router
